import React from 'react';
const SILENT_TEXT = '<!-- 500 -->';
const InternalServerErrorPage = () =>  {
    return <h1 dangerouslySetInnerHTML={{__html: SILENT_TEXT}} />;
};

export default InternalServerErrorPage;



// WEBPACK FOOTER //
// ./app/components/core/InternalServerErrorPage.js